import { Outlet, useNavigate, useLocation } from "react-router-dom";
import React, { useEffect, useState, useRef } from "react";
import { CheckInProvider } from "./checkin-context";

export const CheckInPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const initializedRef = useRef(false);

  const [selectedDate, setSelectedDate] = useState(
    () => location.state?.selectedDate
  );
  const [feelingName, setfeelingName] = useState(
    () => location.state?.feelingName
  );
  const [existingRecord, setExistingRecord] = useState(
    () => location.state?.enableDelete || location.state?.existingRecord
  );

  useEffect(() => {
    if (location.state) {
      if (location.state.feelingName) {
        setfeelingName(location.state.feelingName);
      }
      if (location.state.selectedDate) {
        setSelectedDate(location.state.selectedDate);
      }
      const newExistingRecord =
        location.state.enableDelete || location.state.existingRecord;
      if (newExistingRecord) {
        setExistingRecord((prev: any) => {
          if (
            prev &&
            typeof prev === "object" &&
            typeof newExistingRecord === "object"
          ) {
            return prev.id === newExistingRecord.id ? prev : newExistingRecord;
          }
          return newExistingRecord;
        });
      }
    }
    if (!initializedRef.current) {
      initializedRef.current = true;
    }
  }, [location.pathname]);

  useEffect(() => {
    if (!initializedRef.current) return;

    console.log("erx " + JSON.stringify(existingRecord));
    console.log("selectedDate:", selectedDate);
    console.log("feelingName:", feelingName);
    console.log("current pathname:", location.pathname);

    const hasExistingRecord =
      existingRecord && typeof existingRecord === "object" && existingRecord.id;

    if (hasExistingRecord) {
      if (location.pathname !== "/app/checkin/view") {
        console.log("Navigating to /app/checkin/view");
        navigate("/app/checkin/view", { replace: true });
      }
      return;
    }

    if (selectedDate && feelingName) {
      if (location.pathname !== "/app/checkin/add") {
        console.log("Navigating to /app/checkin/add");
        navigate("/app/checkin/add", { replace: true });
      }
    }
  }, [existingRecord, selectedDate, feelingName, location.pathname]);

  return (
    <CheckInProvider
      initialfeelingName={feelingName}
      initialSelectedDate={selectedDate}
      initialExistingRecord={existingRecord}
    >
      <Outlet />
    </CheckInProvider>
  );
};
